// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"defs","attrs":{},"children":[{"tag":"mask","attrs":{"id":"props.overlapMaskId_fill1","maskUnits":"userSpaceOnUse","maskContentUnits":"userSpaceOnUse","mask-type":"luminance","x":"0","y":"0","width":"24","height":"24"},"children":[{"tag":"rect","attrs":{"x":"0","y":"0","width":"24","height":"24","fill":"#fff"}},{"tag":"path","attrs":{"stroke":"#000","d":"M17.5 13L12 20.25L6.5 13H10V3H14V13H17.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth","fill":"none"}}]}]},{"tag":"g","attrs":{"id":"arrow-triangle-down"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M17.5 13L12 20.25L6.5 13H10V3H14V13H17.5Z","mask":"props.overlapMaskUrl_fill1"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M17.5 13L12 20.25L6.5 13H10V3H14V13H17.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ArrowTriangleDownIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'arrow-triangle-down',
    ref,
    icon: element,
  },
));

ArrowTriangleDownIcon.displayName = 'ArrowTriangleDownIcon';

export default ArrowTriangleDownIcon;
